import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import BackToTop from '../components/BackToTop';
import { WOW } from 'wowjs';
import '../css/global.css';
import '../css/HelpFAQ.css';

const HelpFAQ = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        const wow = new WOW({
            live: false
        });
        wow.init();
    }, []);

    return (
        <div className="help-faq-page">
            <Header />
            
            <Banner 
                backgroundImage="/wp-content/uploads/2016/02/FAQ.jpg" 
                title="Help / FAQ"
            />

            <section className="contentwrapper clearfix">
                <div className="content clearfix">
                    <div className="breadcrumbs">
                        <a href="/">Home</a> &gt; <span>HelpFAQ</span>
                    </div>
                    
                    <h1>Help / FAQ</h1>

                    <div className="faq-content">
                        <h2>Frequently Asked Questions (FAQ)</h2>
                        <br />

                        <div className="faq-item">
                            <strong>1. What is this policy about?</strong>
                            <p>This policy outlines how Colombo Dockyard PLC collects, stores, and safeguards your personal information when you interact with our website. We are committed to maintaining the confidentiality and security of your data.</p>
                        </div>

                        <div className="faq-item">
                            <strong>2. What kind of information do you collect?</strong>
                            <p>We may collect the following personal and non-personal information to enhance your browsing experience:</p>
                            <ul>
                                <li>Full name and contact details (email, phone)</li>
                                <li>Company name and job title (if applicable)</li>
                                <li>Demographic information (e.g., preferences, location)</li>
                                <li>Website usage statistics through cookies and analytics tools</li>
                            </ul>
                        </div>

                        <div className="faq-item">
                            <strong>3. Why do you collect this information?</strong>
                            <p>Information collected is used for:</p>
                            <ul>
                                <li>Responding to inquiries and service requests</li>
                                <li>Improving website performance and usability</li>
                                <li>Internal record keeping and communication</li>
                                <li>Providing relevant updates and offers, with your consent</li>
                            </ul>
                        </div>

                        <div className="faq-item">
                            <strong>4. How do you ensure my information is secure?</strong>
                            <p>Colombo Dockyard PLC uses strict security protocols, including secure servers, encryption, and restricted access procedures, to protect all personal data from unauthorized access or disclosure.</p>
                        </div>

                        <div className="faq-item">
                            <strong>5. Do you use cookies?</strong>
                            <p>Yes. Our website uses cookies to:</p>
                            <ul>
                                <li>Analyze traffic and user behavior</li>
                                <li>Remember user preferences for a personalized experience</li>
                            </ul>
                            <p>Cookies do not grant us access to your personal files or information without your consent. You may disable cookies via your browser settings, although this may impact site functionality.</p>
                        </div>

                        <div className="faq-item">
                            <strong>6. Do you link to other websites?</strong>
                            <p>Our website may include links to third-party websites. Please note that we are not responsible for the privacy practices or content of external sites. We encourage users to read their respective privacy policies.</p>
                        </div>

                        <div className="faq-item">
                            <strong>7. How can I control my personal information?</strong>
                            <p>You may control the use of your personal information by:</p>
                            <ul>
                                <li>Opting out of marketing communications at any time</li>
                                <li>Updating your contact preferences by emailing us at <a href="mailto:coldock@cdl.lk">coldock@cdl.lk</a></li>
                            </ul>
                        </div>

                        <div className="faq-item">
                            <strong>8. Will you share my information with others?</strong>
                            <p>We do <strong>not</strong> sell or lease your personal data to third parties. We may share it only when required by law or when you have provided explicit consent.</p>
                        </div>

                        <div className="faq-item">
                            <strong>9. What if my information is incorrect?</strong>
                            <p>If you believe any information we hold is incorrect or outdated, please contact us immediately at <a href="mailto:coldock@cdl.lk">coldock@cdl.lk</a>. We are committed to promptly correcting any inaccuracies.</p>
                        </div>

                        <div className="faq-item">
                            <strong>10. How can I contact Colombo Dockyard PLC?</strong>
                            <ul>
                                <li><strong>Head Office:</strong> Colombo Dockyard PLC, No. 12, Chaithya Road, Colombo 01, Sri Lanka</li>
                                <li><strong>Phone:</strong> +94 11 242 9000</li>
                                <li><strong>Email:</strong> <a href="mailto:coldock@cdl.lk">coldock@cdl.lk</a></li>
                                <li><strong>Website:</strong> <a href="https://cdl.lk" target="_blank" rel="noopener noreferrer">https://cdl.lk</a></li>
                            </ul>
                        </div>

                        <div className="faq-item">
                            <strong>11. When was this policy last updated?</strong>
                            <p>This privacy policy is subject to periodic updates. We encourage you to review this page regularly to stay informed of any changes. The most recent update reflects practices as of <strong>June 2025</strong>.</p>
                        </div>

                    </div>
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
};

export default HelpFAQ;
